import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebAuthorizedLayoutComponent } from './web-authorized-layout.component';
import { RouterModule } from '@angular/router';
import { SchoolLogoModule } from '../school-logo/school-logo.module';
import { MenuModule } from '../menu/menu.module';
import { UserProfileModule } from '../user-profile/user-profile.module';
import { NgProgressModule } from 'ngx-progressbar';
import { BackButtonModule } from '../../common/back-button/back-button.module';
import { ClickOutsideModule } from '../../directives/clickOutside';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SchoolLogoModule,
    MenuModule,
    UserProfileModule,
    BackButtonModule,
    ClickOutsideModule,
    NgProgressModule.withConfig({
      trickleSpeed: 200,
      min: 20,
      meteor: false
    }),
  ],
  declarations: [WebAuthorizedLayoutComponent]
})
export class WebAuthorizedLayoutModule { }
